import {
    CompareTileSnippetBody,
    ConditionalShopTileBlock,
    ConditionalShopTileBody,
} from "@reactivated";

import { InternalProduct } from "./catalogue";
import { FinancingPlans } from "./financing";

export const ATTRIBUTE_CLASSES = {
    soft: "Soft",
    medium: "Medium",
    hybrid: "Medium Hybrid",
    firm: "Firm",
} as const;

type FeelAttributesType =
    (typeof ATTRIBUTE_CLASSES)[keyof typeof ATTRIBUTE_CLASSES];

// Abstract shared type for common product tile fields
export type AbstractProductTileData = {
    price: InternalProduct["price"];
    financing_plans?: FinancingPlans;
    num_reviews: InternalProduct["num_reviews"];
    link: InternalProduct["link"];
    rating: InternalProduct["rating"];
    feel_options: readonly FeelAttributesType[];
    feel_option_display_names?: Record<string, string>;
    size_options: readonly string[];
    children?: readonly InternalProduct[];
};

export type CompareTileType = CompareTileSnippetBody[number]["value"] &
    AbstractProductTileData;

export type ShopTileType = ConditionalShopTileBlock & {
    shop_tile: ConditionalShopTileBlock["shop_tile"] & AbstractProductTileData;
};

const isShopTileActive = (tile: ConditionalShopTileBody[number]): boolean =>
    !tile.value.promo_period || !!tile.value.promo_period.is_promo_active;

export const getActiveShopTiles = (
    tiles: ConditionalShopTileBody | null | undefined,
): ConditionalShopTileBody => (tiles ?? []).filter(isShopTileActive);
